module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail1.195675a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail1.jpg
// module id = n8Zz
// module chunks = 6